import runAfterPageLoad from "./runAfterPageLoad.js";

export default function adminAppointments() {
  runAfterPageLoad(initAdminAppointments);
}

function initAdminAppointments() {
  const cancelAllCheckbox = document.querySelector(
    ".appointment_cancel_all_bookings"
  );

  if (cancelAllCheckbox) {
    cancelAllCheckbox.addEventListener("change", (event) => {
      const { checked } = event.target;

      document
        .querySelectorAll(".appointment_bookings_booked_cancel")
        .forEach((elem) => {
          const elemWrapper = elem.querySelector(".form-checkbox-js");

          if (elemWrapper) {
            const elemChecked = elemWrapper.classList.contains("checked");

            if (checked !== elemChecked) {
              elem.querySelector("label").click();
            }
          }
        });
    });
  }
}
